import { Button, Result } from 'antd'
import { useNavigate } from 'react-router-dom'

export function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <Result
      status="404"
      title="Page Not Found"
      subTitle="Sorry, the page you're looking for doesn't exist."
      extra={[
        <Button type="primary" key="home" onClick={() => navigate('/')}>
          Go to Dashboard
        </Button>,
        <Button key="back" onClick={() => navigate(-1)}>
          Go Back
        </Button>,
      ]}
    />
  )
}
